export interface ProductTarget {
  bodyType: string;
  fuelType: string;
  make: string;
  model: string;
}

export interface ProductDetail {
  code: string;
  leadType: string;
  productTarget: ProductTarget;
  sourceId: string;
  state: 'MATCHED' | 'NOT_MATCHED';
  type: string;
  matchType: keyof typeof matchType;
}

export const matchType = {
  BODY_AND_FUEL_TYPE: 'body style and fuelling type of the vehicle',
  BODY_TYPE: 'body style of the vehicle',
  FUEL_TYPE: 'fuelling type of the vehicle',
  MAKE_AND_MODEL: 'vehicle',
  DEFAULT: 'vehicle',
};

export function isMatchTypeValue(value: string): value is keyof typeof matchType {
  return Object.hasOwn(matchType, value);
}
